<script lang="ts">
    import FeatherIcon from 'svelte-feather-icon'
    import { Col, Row } from 'sveltestrap'
    import Card from '../../Core/Card.svelte'
    import {latestArticalFaqData} from '../../../Data/FAQ/FAQ'
</script>
  
{#each latestArticalFaqData as subItem}
    <Col xl={subItem.classxl} md={subItem.classmd}>
      <Row>
        {#each subItem.alldata as faqItem}
          <Col sm={faqItem.classsm} xl={faqItem.classxl} md={faqItem.classmd}>
            <Card>
              <div slot="contentbody">
                <div class="media gap-3">
                  <FeatherIcon class="m-r-30" icon={faqItem.icon} />
                  <div class="media-body">
                    <h6 class="f-w-600">{faqItem.title}</h6>
                    <p>{faqItem.paragraph}</p>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
        {/each}
      </Row>
    </Col>
{/each}
  